<template>
    <div>
        <div class="notFound" @click="goback()">
        </div>
    </div>
</template>

<style scoped>
    .notFound{
        background:url('../../assets/images/404.png') center center no-repeat;
        width: 100%;
        height: 500px;
        cursor: pointer;
    }
</style>

<script>
export default {
    methods: {
        goback() {
            history.go(-1);
        }
    }
}
</script>